import React from 'react';
import styled from 'styled-components';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';
import { Colors } from '~/src/scss/common/style';

export default function DbResultBox({ food, setNutriFacts }): JSX.Element {
  return (
    <Container>
      <div>
        <FoodName>{food.name}</FoodName>
      </div>
      <div>
        <div style={{ float: 'right' }}>{food.gtinUpc}</div>
        <div>
          Src: <b>{food.type}</b>
          <br />
          {food.fdcId && `FDCID: ${food.fdcId}`}
        </div>
      </div>
      <PrimaryButton
        title="Select"
        onClick={() => {
          setNutriFacts(food);
        }}
      />
    </Container>
  );
}

const FoodName = styled.div`
  font-size: 14px;
  color: ${Colors.newOrage};
  font-weight: 700;
  margin-bottom: 7px;
`;

const Container = styled.div`
  padding: 15px;
  margin-bottom: 5px;
  background: rgba(239, 125, 0, 0.09);
  border: 2px solid ${Colors.newOrage};
  border-radius: 10px;
`;
